import classNames from 'classnames'
import { isRedesignEnabled } from 'finviz-charts/app/utils'
import * as React from 'react'

interface Props extends React.HTMLProps<HTMLDivElement> {
  leftContent?: React.ReactNode
  middleContent?: React.ReactNode
  rightContent?: React.ReactNode
}

export function SubMenu({ leftContent, middleContent, rightContent, ...props }: Props) {
  return (
    <div {...props} className={classNames('border-b border-gray-100 bg-primary dark:border-gray-700', props.className)}>
      <div className="fv-container has-responsive-padding flex items-center justify-between space-x-2.5">
        <div
          className={classNames('-ml-2.5 flex items-center', {
            '-ml-2.5 mr-2.5': isRedesignEnabled(),
          })}
        >
          {leftContent}
        </div>
        {middleContent && <div className="flex items-center">{middleContent}</div>}
        <div className="flex items-center">{rightContent}</div>
      </div>
    </div>
  )
}
